import * as React from "react"
import { FunctionComponent } from "react"
import {
	EAutoSuggestType,
	IFactFinderAutoSuggest,
	IFactFinderAutoSuggestWrapper
} from "../../interfaces/i-fact-finder-auto-suggest"
import { FlapOutDefaultResult } from "./flap-out-default-result"
import { FlapOutProductResult } from "./flap-out-product-result"

interface IFlapOutDisplayFilterProps {
	searchResult: IFactFinderAutoSuggestWrapper
	filterType: EAutoSuggestType
	headline: string,
	searchQuery: string
}

export const FlapOutDisplayFilter: FunctionComponent<IFlapOutDisplayFilterProps> = (
	props: IFlapOutDisplayFilterProps
) => {
	const { searchResult, filterType, headline, searchQuery } = props

	return (
		<>
		{searchResult.suggestions.filter((suggestion: IFactFinderAutoSuggest) =>
					suggestion.type === EAutoSuggestType[filterType]).length > 0 && 
			<div className="autosuggest__section">
				<p className="autosuggest__cat">{headline}</p>
				{searchResult.suggestions.filter(
					(suggestion: IFactFinderAutoSuggest) =>
						suggestion.type === EAutoSuggestType[filterType]
				).map((suggestion: IFactFinderAutoSuggest,index) => {
					return (
						<React.Fragment key={index}>
							{(filterType === EAutoSuggestType.category ||
								filterType === EAutoSuggestType.searchTerm) && (
								<FlapOutDefaultResult key={index} searchQuery={searchQuery} suggestion={suggestion} />
							)}
							{filterType === EAutoSuggestType.productName && (
								<FlapOutProductResult key={index} searchQuery={searchQuery} suggestion={suggestion} />
							)}
						</React.Fragment>
					)
				})}
			</div>
		}
		</>
	)
}
